import { render, staticRenderFns } from "./signatureInput.vue?vue&type=template&id=10658850&scoped=true&"
import script from "./signatureInput.vue?vue&type=script&lang=ts&"
export * from "./signatureInput.vue?vue&type=script&lang=ts&"
import style0 from "./signatureInput.vue?vue&type=style&index=0&id=10658850&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10658850",
  null
  
)

export default component.exports